import { observer } from 'mobx-react';
import React from 'react';
import TableToolbar from '../../shared/tableToolbar';
import M4ModifierExclusionStore from './Store';
import * as api from '../../../stores/api';

@observer
class M4ModifierExclusionToolbar extends React.Component {
  handleSearchChange = (_, { value }) => {
    M4ModifierExclusionStore.setFieldsValue({ keyword: value });
  };

  handleSubmit = e => {
    e.preventDefault();
    M4ModifierExclusionStore.refetch({}, true);
  };

  handleReset = () => {
    M4ModifierExclusionStore.resetStore();
  };

  handleCreate = () => {
    return M4ModifierExclusionStore.toggleModal(true, { modalType: 'create' })();
  };

  render() {
    const { keyword, loading } = M4ModifierExclusionStore;
    return (
      <TableToolbar.Container>
        <TableToolbar.Left onSubmit={this.handleSubmit}>
          <TableToolbar.Input
            placeholder="Search"
            value={keyword}
            onChange={this.handleSearchChange}
            disabled={loading}
          />
          <TableToolbar.SubmitButton disabled={loading}>Search</TableToolbar.SubmitButton>
          <TableToolbar.HighLightButton
            className="negative"
            disabled={loading}
            onClick={this.handleReset}
            style={{ marginLeft: '5px' }}
          >
            Clear
          </TableToolbar.HighLightButton>
        </TableToolbar.Left>
        <TableToolbar.Right>
          {api.isAdminOrMagStaffOrAccounting() && (
            <TableToolbar.HighLightButton className="positive" disabled={loading} onClick={this.handleCreate}>
              Add Code
            </TableToolbar.HighLightButton>
          )}
        </TableToolbar.Right>
      </TableToolbar.Container>
    );
  }
}

export default M4ModifierExclusionToolbar;
